module.exports = __webpack_public_path__ + "static/media/screen-share.cbf02c39.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/screen-share.jpeg
// module id = 1667
// module chunks = 0